// src/KeycloakService.js
import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: 'https://idms.test.veridos-egov.com/auth',
  realm: 'did_public',
  clientId: 'verifier',
});

export default keycloak;
